<template>
  <pt-news-detail class="pt-news-detail__withData" :newsDetail="newsDetail" :loading="loading"></pt-news-detail>
</template>

<script>
import PtNewsDetail from './index'
export default {
  name: 'pt-news-detail__withData',
  components: {
    'pt-news-detail': PtNewsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newsDetail: {},
      loading: false
    }
  },
  methods: {
    getNewsDetail () {
      this.loading = true
      this.$store.dispatch('newsDetail', this.id).then(res => {
        this.newsDetail = res
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取新闻详情失败')
        this.loading = false
      })
    }
  },
  created () {
    this.getNewsDetail()
  }
}
</script>
